import React from "react";
import siteText from "../assets/siteText.json";
import { buildSrcSets } from "../utils/imageSrcSet";
import "../App.css";
import "./ThingsToDo.css";

// Cards show images at 220x140 CSS px; 240w covers 1x screens and 480w covers 2x.
// Variants are made by scripts/optimize-images.mjs from the originals in public/images.
const CARD_WIDTHS = [240, 480];
const CARD_SIZES = "220px";

// "images/IMG_1854.JPG" -> "IMG_1854"
const baseName = (imagePath) => imagePath.split("/").pop().replace(/\.[^.]+$/, "");

function ThingsToDo() {
  return (
    <div className="things-to-do-page">
      <h1>{siteText.thingsToDo.header}</h1>
      <p>{siteText.thingsToDo.intro}</p>
      <div className="activities-grid">
        {siteText.thingsToDo.activities.map((item, idx) => (
          <a
            href={item.link}
            key={idx}
            className="activity-card"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: 'none', color: 'inherit', display: 'flex', flexDirection: 'column', alignItems: 'center' }}
          >
            {item.image && (() => {
              const { srcSetWebp, srcSetJpg } = buildSrcSets(baseName(item.image), CARD_WIDTHS);
              return (
                <picture style={{ display: "block", width: "100%", maxWidth: 220 }}>
                  <source type="image/webp" srcSet={srcSetWebp} sizes={CARD_SIZES} />
                  <img
                    src={`${process.env.PUBLIC_URL || ""}/images/optimized/${baseName(item.image)}-w480.jpg`}
                    srcSet={srcSetJpg}
                    sizes={CARD_SIZES}
                    alt={item.title}
                    width={220}
                    height={140}
                    loading={idx === 0 ? "eager" : "lazy"}
                    decoding="async"
                    className="activity-image"
                    style={{ width: '100%', maxWidth: 220, height: 140, objectFit: 'cover', borderRadius: 10, marginBottom: '1rem', boxShadow: '0 2px 8px rgba(0,0,0,0.13)' }}
                  />
                </picture>
              );
            })()}
            <h2 style={{ margin: '0.5rem 0 0.5rem 0', textAlign: 'center' }}>{item.title}</h2>
            <p style={{ fontSize: '1rem', color: '#444', textAlign: 'center' }}>{item.description}</p>
          </a>
        ))}
      </div>
    </div>
  );
}

export default ThingsToDo;
